module.exports = __webpack_public_path__ + "static/media/spotify-podcast.382f4269.svg";